import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/tick.png';
const _withScopeId = n => (_pushScopeId("data-v-4f5d7c4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "invoicePage" };
const _hoisted_2 = { class: "invoiceBox" };
const _hoisted_3 = { class: "invoiceHeader flex-align-center" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, [
    /*#__PURE__*/ _createTextVNode(" 抬头类型"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_5 = { class: "selectRadio flex-align-center" };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 个人 ");
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" 企业 ");
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = { class: "invoiceBox" };
const _hoisted_13 = { class: "invoiceList flex-align-center" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, [
    /*#__PURE__*/ _createTextVNode("发票抬头"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_15 = {
    key: 0,
    class: "invoiceList flex-align-center"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, [
    /*#__PURE__*/ _createTextVNode("税号"),
    /*#__PURE__*/ _createElementVNode("span", { class: "colorR" }, "*")
], -1));
const _hoisted_17 = { class: "invoiceList flex-align-center" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "电子邮箱", -1));
const _hoisted_19 = { class: "invoiceList flex-align-center" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "开户银行", -1));
const _hoisted_21 = { class: "invoiceList flex-align-center" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "银行账号", -1));
const _hoisted_23 = { class: "invoiceList flex-align-center" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "注册地址", -1));
const _hoisted_25 = { class: "invoiceList flex-align-center" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "tax-number" }, "注册电话", -1));
const _hoisted_27 = { class: "invoiceBox" };
const _hoisted_28 = { class: "invoiceHeader selectRadio flex-align-center" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "invoice-content" }, " 设为默认 ", -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_31 = [
    _hoisted_30
];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", {
    class: "submitInput",
    type: "submit"
}, "保存", -1));
const _hoisted_34 = [
    _hoisted_33
];
import { useRoute, useRouter } from 'vue-router';
import { Toast } from 'vant';
import { addInvoice, templateDetail, updataInvoice } from '@/api/invoice';
import { appPort, closeWebView, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { ref, reactive } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const isApp = ref(appPort());
        const orderId = route.query.orderId;
        const orderType = String(route.query.type).toUpperCase() || 'MEETING';
        const { invoiceTemplateId } = route.query;
        const formData = reactive({
            isDefault: false,
            invoiceType: '1',
            invoiceTypePersonalCompany: 2,
            invoiceTitle: '',
            companyNo: '',
            companyAddr: '',
            companyPhone: '',
            companyBank: '',
            companyBankNo: '',
            email: ''
        });
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        // 判断是否编辑数据
        const isEdit = route.path === '/invoicEdit/header';
        /* 返回 */
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        /* 校验税号 */
        const validCompanyNo = () => {
            const regex = /^[a-zA-Z0-9]{15,20}$/;
            if (formData.companyNo && !regex.test(formData.companyNo)) {
                Toast('请输入有效的发票税号');
            }
        };
        /* 校验邮箱 */
        const validEmail = () => {
            const regexEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            if (formData.email && !regexEmail.test(formData.email)) {
                Toast('电子邮箱格式不正确');
            }
        };
        /* 校验银行账号 */
        const validCompanyBankNo = () => {
            const regexCompanyBankNo = /^\d{16,19}$/;
            if (formData.companyBankNo &&
                !regexCompanyBankNo.test(formData.companyBankNo)) {
                Toast('银行账号格式不正确');
            }
        };
        /* 校验手机号格式 */
        // const validPhone = () => {
        //   const regexPhone = /^1[3-9]\d{9}$/
        //   if (formData.companyPhone && !regexPhone.test(formData.companyPhone)) {
        //     Toast('手机号格式不正确')
        //     return
        //   }
        // }
        /* 选择抬头类型 */
        const selectHeader = (type) => {
            formData.invoiceTypePersonalCompany = type;
        };
        /* 设置默认地址 */
        const setDefault = val => {
            formData.isDefault = !formData.isDefault;
        };
        /* 保存 */
        const saveTemplate = () => {
            /* 企业时才需要填税号 */
            if (formData.invoiceTypePersonalCompany === 2) {
                if (!formData.companyNo) {
                    Toast('请填写税号');
                    return;
                }
                else {
                    const regex = /^[a-zA-Z0-9]{15,20}$/;
                    if (!regex.test(formData.companyNo)) {
                        Toast('请输入有效的发票税号');
                        return;
                    }
                }
            }
            if (!formData.invoiceTitle) {
                Toast('请填写发票抬头');
                return;
            }
            if (formData.email) {
                const regexEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                if (formData.email && !regexEmail.test(formData.email)) {
                    Toast('电子邮箱格式不正确');
                    return;
                }
            }
            // const regexPhone = /^1[3-9]\d{9}$/
            // if (formData.companyPhone && !regexPhone.test(formData.companyPhone)) {
            //   Toast('手机号格式不正确')
            //   return
            // }
            const regexCompanyBankNo = /^\d{16,19}$/;
            if (formData.companyBankNo &&
                !regexCompanyBankNo.test(formData.companyBankNo)) {
                Toast('银行账号格式不正确');
                return;
            }
            if (isEdit) {
                updateData();
            }
            else {
                addData();
            }
        };
        /* 添加 */
        const addData = () => {
            const { isDefault, invoiceType, invoiceTypePersonalCompany, invoiceTitle, companyNo, companyAddr, companyPhone, companyBank, companyBankNo, email } = formData;
            addInvoice({
                isDefault: isDefault ? 1 : 0,
                invoiceType,
                invoiceTypePersonalCompany,
                invoiceTitle,
                companyNo,
                companyAddr,
                companyPhone,
                companyBank,
                companyBankNo,
                email
            }).then((res) => {
                if (res.code === 200) {
                    Toast('新增发票模板成功！');
                    router.replace(`/invoice/${orderId}?type=${orderType}`);
                }
                else {
                    Toast(res.message);
                }
            });
        };
        /* 修改 */
        const updateData = () => {
            const { isDefault, invoiceType, invoiceTypePersonalCompany, invoiceTitle, companyNo, companyAddr, companyPhone, companyBank, companyBankNo, email } = formData;
            updataInvoice({
                invoiceTemplateId: Number(invoiceTemplateId),
                isDefault,
                invoiceType,
                invoiceTypePersonalCompany,
                invoiceTitle,
                companyNo,
                companyAddr,
                companyPhone,
                companyBank,
                companyBankNo,
                email
            }).then((res) => {
                if (res.code === 200) {
                    Toast('修改发票模版成功!');
                    router.replace(`/invoice/${orderId}?type=${orderType}`);
                }
                else {
                    Toast(res.message);
                }
            });
        };
        // 发票模版详情查询
        if (invoiceTemplateId) {
            templateDetail({
                invoiceTemplateId: Number(invoiceTemplateId)
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    formData.invoiceTitle = data?.invoiceTitle;
                    formData.companyNo = data?.companyNo;
                    formData.email = data?.email;
                    formData.companyBank = data?.companyBank;
                    formData.companyBankNo = data?.companyBankNo;
                    formData.companyPhone = data?.companyPhone;
                    formData.companyAddr = data?.companyAddr;
                    formData.isDefault = data?.isDefault;
                    formData.invoiceTypePersonalCompany =
                        data?.invoiceTypePersonalCompany || 1;
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '添加抬头'
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("label", {
                                class: "radio-container",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (selectHeader(1)), ["stop"]))
                            }, [
                                _hoisted_6,
                                _createElementVNode("span", {
                                    class: _normalizeClass(["checkmark", { active: _unref(formData).invoiceTypePersonalCompany === 1 }])
                                }, _hoisted_8, 2)
                            ]),
                            _createElementVNode("label", {
                                class: "radio-container",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (selectHeader(2)), ["stop"]))
                            }, [
                                _hoisted_9,
                                _createElementVNode("span", {
                                    class: _normalizeClass(["checkmark", { active: _unref(formData).invoiceTypePersonalCompany === 2 }])
                                }, _hoisted_11, 2)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("ul", _hoisted_12, [
                    _createElementVNode("li", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                            id: "tax-number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(formData).invoiceTitle) = $event)),
                            placeholder: "请输入公司名称",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _unref(formData).invoiceTitle]
                        ])
                    ]),
                    (_unref(formData).invoiceTypePersonalCompany === 2)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                            _hoisted_16,
                            _withDirectives(_createElementVNode("input", {
                                maxlength: "20",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(formData).companyNo) = $event)),
                                placeholder: "请输入纳税人识别号",
                                required: "",
                                onBlur: validCompanyNo
                            }, null, 544), [
                                [_vModelText, _unref(formData).companyNo]
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("li", _hoisted_17, [
                        _hoisted_18,
                        _withDirectives(_createElementVNode("input", {
                            maxlength: "30",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(formData).email) = $event)),
                            placeholder: "用于接收电子发票",
                            onBlur: validEmail,
                            required: ""
                        }, null, 544), [
                            [_vModelText, _unref(formData).email]
                        ])
                    ]),
                    (_unref(formData).invoiceTypePersonalCompany === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("li", _hoisted_19, [
                                _hoisted_20,
                                _withDirectives(_createElementVNode("input", {
                                    id: "tax-number",
                                    maxlength: "30",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(formData).companyBank) = $event)),
                                    placeholder: "选填",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(formData).companyBank]
                                ])
                            ]),
                            _createElementVNode("li", _hoisted_21, [
                                _hoisted_22,
                                _withDirectives(_createElementVNode("input", {
                                    id: "tax-number",
                                    maxlength: "30",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(formData).companyBankNo) = $event)),
                                    onBlur: validCompanyBankNo,
                                    placeholder: "选填",
                                    required: ""
                                }, null, 544), [
                                    [_vModelText, _unref(formData).companyBankNo]
                                ])
                            ]),
                            _createElementVNode("li", _hoisted_23, [
                                _hoisted_24,
                                _withDirectives(_createElementVNode("input", {
                                    id: "tax-number",
                                    maxlength: "30",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(formData).companyAddr) = $event)),
                                    placeholder: "选填",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(formData).companyAddr]
                                ])
                            ]),
                            _createElementVNode("li", _hoisted_25, [
                                _hoisted_26,
                                _withDirectives(_createElementVNode("input", {
                                    id: "tax-number",
                                    maxlength: "30",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(formData).companyPhone) = $event)),
                                    placeholder: "选填",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(formData).companyPhone]
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", {
                            class: "radio-container radioBtn",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (setDefault(_unref(formData).isDefault)), ["stop"]))
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["checkmark", { active: _unref(formData).isDefault }])
                            }, _hoisted_31, 2)
                        ])
                    ])
                ]),
                _createElementVNode("div", {
                    class: "bottomBtn",
                    onClick: _withModifiers(saveTemplate, ["stop"])
                }, _hoisted_34, 8, _hoisted_32)
            ]));
        };
    }
});
